import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            按分类浏览成91相关内容，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer flex items-start gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500 flex-shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">{cat.description}</p>
                <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}